export default __webpack_public_path__ + "static/media/TaskeemIcon.7983456a.svg";